export default __webpack_public_path__ + "static/club-gallery-1-ab3fef1eeded9f94b75d99e01ce147c1.webp";